import { AffectedCompanyModel, CompanyExceptionModel } from 'modules/payroll-settings/wage-indexation/types';
import { RootState } from 'store';
import { IMinimumWage } from 'types/minimum-wage';

export const wageIndexationSelector = (state: RootState): IMinimumWage[] => state.wageIndexation.wageIndexation;

export const wageIndexationPreviewSelector = (state: RootState): IMinimumWage[] =>
  state.wageIndexation.wageIndexationPreview;

export const companiesWithExceptionsSelector = (state: RootState): CompanyExceptionModel[] =>
  state.wageIndexation.companiesWithExceptions;

export const affectedCompaniesSelector = (state: RootState): AffectedCompanyModel[] =>
  state.wageIndexation.affectedCompanies;
